т<template>
  <div>
    <div class="reviews d-none d-md-block">
      <div class="reviews__list">
        <div class="reviews__slider">
          <div
            v-for="(slide, i) in items"
            :key="slide.company"
            class="review"
            :class="{ active: activeSlide === i }"
          >
            <div class="review__text my-5">
              {{ slide.content }}
            </div>
            <div class="font-weight-bold">
              {{ slide.company }}
            </div>
          </div>
        </div>
      </div>
      <svg
        class="reviews__arrow reviews__prev"
        width="22"
        height="49"
        viewBox="0 0 22 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="slider(false)"
      >
        <path d="M21 48L1 24L21 1" stroke="black" stroke-opacity="0.5" />
      </svg>
      <svg
        class="reviews__arrow reviews__next"
        width="22"
        height="49"
        viewBox="0 0 22 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="slider(true)"
      >
        <path d="M1 48L21 24L0.999998 1" stroke="black" stroke-opacity="0.5" />
      </svg>
    </div>
    <VCarousel
      v-model="activeSlide"
      hide-delimiter-background
      :show-arrows="false"
      class="d-md-none"
      height="480"
      light
    >
      <VCarouselItem
        v-for="slide in items"
        :key="slide.key"
      >
        <div class="review__text my-5">
          {{ slide.content }}
        </div>
        <div class="font-weight-bold">
          {{ slide.company }}
        </div>
      </VCarouselItem>
    </VCarousel>
  </div>
</template>

<script>
export default {
  name: 'Reviews',
  data() {
    return {
      activeSlide: 0,
      activeDesktop: 0,
    };
  },
  computed: {
    items() {
      return [
        {
          company: this.$t('company1'),
          content: this.$t('content1'),
        },
        {
          company: this.$t('company2'),
          content: this.$t('content2'),
        },
        {
          company: this.$t('company3'),
          content: this.$t('content3'),
        },
        {
          company: this.$t('company4'),
          content: this.$t('content4'),
        },
        {
          company: this.$t('company5'),
          content: this.$t('content5'),
        },
        {
          company: this.$t('company6'),
          content: this.$t('content6'),
        },
        {
          company: this.$t('company7'),
          content: this.$t('content7'),
        },
      ];
    },
  },
  methods: {
    slider(sign) {
      if (sign && this.activeDesktop < this.items.length / 2 - 1) {
        this.activeDesktop += 1;
      } else if (!sign && this.activeDesktop > 0) {
        this.activeDesktop -= 1;
      } else {
        return false;
      }
      const root = document.querySelector('.reviews');
      root.style.setProperty('--margin', `-${100 * this.activeDesktop}%`);
      return true;
    },
    getImgUrl(logo) {
      const images = require.context('../../assets/img/landing/logotypes/', false, /\.png$/);
      // eslint-disable-next-line prefer-template
      return images('./' + logo);
    },
    swipeIt(e) {
      switch (e) {
        case 'left':
          // eslint-disable-next-line max-len
          this.activeSlide = this.activeSlide < this.items.length - 1 ? this.activeSlide + 1 : this.activeSlide;
          break;
        case 'right':
          // eslint-disable-next-line max-len
          this.activeSlide = this.activeSlide > 0 ? this.activeSlide - 1 : this.activeSlide;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.reviews {
  .v-slide-group__prev,
  .v-slide-group__next {
    display: none;
  }
  --margin: 0;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .review:first-child {
      margin-left: var(--margin);
    }
  }
}
</style>
<style scoped lang="scss">
.reviews {
  display: flex;
  overflow: hidden;
  position: relative;
  &__list {
    overflow: hidden;
  }
  &__slider {
    display: flex;
    transition: 0.3s;
    position: relative;
  }
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: none;
  }
  &__prev {
    left: 10px;
  }
  &__next {
    right: 10px;
  }
}
div.review__logo {
  width: 80px;
  height: 80px;
  background: #b8b8b8;
  border-radius: 50%;

  svg {
    width: 70%;
    height: 70%;
  }
}
.review {
  width: calc(100vw - #{$spacer * 7});
  padding-right: $spacer * 7;
  flex: 0 0 auto;
  white-space: initial;
  box-sizing: border-box;
  transition: 0.3s;
  &:not(.active) {
    display: none;
  }
}


@media #{map-get($display-breakpoints, 'md-and-up')} {
  .reviews {
    padding: 0 50px;
    &__arrow {
      display: block;
    }
  }
  .review {
    padding: 0 50px;
    width: 50%;
    position: relative;
    &:not(.active) {
      display: block;
    }
    &:nth-child(odd) {
      &:after {
        content: '';
        position: absolute;
        top: 20px;
        bottom: 10px;
        right: 0;
        border-right: 1px solid rgba(196, 196, 196, 0.5);
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .review {
    padding: 0 120px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .review__logo {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .review {
    &__text {
      font-size: 0.9375rem;
    }
  }
}
</style>

<!-- eslint-disable max-len -->
<i18n locale="en" lang="yaml">
  content1: 'Huntica’s QR codes made our recruiting much more effective. We printed them on our pastry bags when we opened our second bakery. The result was way beyond our expectations — we received over 50 applicants for each position with the help of our loyal customers and their friends. All we had to do was watch all the interviews and make decisions. We finished onboarding the new employees a week later. We saved a lot of time and effort thanks to this wonderful service.'
  company1: Olive Tree Bakery
  content2: 'We found a valuable recruitment tool when we searched for summer interns with QR codes from Huntica. Instead of handing out our usual application form to students, we posted a QR code generated by Huntica on university notice boards on campus. Hundreds of applications turned into virtual interviews, ready to be assessed by our recruiters. Huntica saved us a lot of work and made the entire process smooth and effective.'
  company2: Theta Kappa
  content3: 'When we had an urgent opening for a top position, we found a great solution from Huntica. They gave us the opportunity to place a QR code on billboards around the city, linking potential employees to an online interview page. It helped to engage with an enthusiastic audience of people looking for work. We had more than 80 interviews recorded in a couple of days. That allowed our HR to put all its efforts into selecting the best candidates for the final interview. The project was completed on time, and we’re very happy with our new team member.'
  company3: Rooftop Strategies
  content4: 'Our company is growing and we are always looking for great professionals to strengthen our team. We organized a meet-up for UX designers and added a QR code from Huntica to the event’s brochure and posters. 8% of the participants used the QR code to record an interview on the Huntica platform. The best part is that they were able to complete most of the process on their own without a single appointment. The service helped us to filter out the best candidates and have them come in for a live interview with the team. This way, we managed to hire a new UX department for experimental projects with the least effort possible.'
  company4: Inkspot Solutions
  content5: 'Our vehicles hire people for us! Putting a QR code on our delivery cars has been a huge advantage for effective recruitment in the transportation field. We target our future drivers where they are more likely to be: on the road. They scan a QR code with their smartphones and follow directions to record a virtual interview. It saves our HR managers lots of work and leaves them only the most interesting part — evaluation and selection of candidates. '
  company5: Red Lion Delivery
  content6: 'Our restaurant always has a few openings. To fill them, we use stickers with a QR code from Huntica. The code links those interested in the job with an online interview page that has a fully automated interview. Since we put stickers on every table and door in the restaurant, our new hires now tend to be fans of our food and service.'
  company6: Mangiando Restaurant
  content7: 'As a local transportation provider, we mainly rely on word of mouth for hiring. It gets us drivers who live close to our routes and hear positive reviews from other commuters who they know. Recently, we added a QR code from Huntica to all our tickets and we now receive twice as many applications as before — all of them with a virtual interview so we don’t have to spend a lot of effort and resources. This service has increased the value of our printed materials and allowed us to recruit while providing our usual services.'
  company7: Fast Pace Lines
</i18n>

<i18n locale="ru" lang="yaml">
  content1: 'Наше маркетинговое агентство всегда радо принять хорошего специалиста в команду, мы предпочитаем находить таланты даже до того, как откроется вакансия. Чтобы пользоваться возможностью находить сотрудников при общении с профессионалами в нашей среде, все корпоративные визитки содержат QR-код с информацией о компании и возможностью пройти онлайн-собеседование. С QR-кодом кандидаты могут проходить собеседование в любое время, а мы — получать отклики от действительно заинтересованных кандидатов.'
  company1: Uphill People
  content2: 'Мы — концертная площадка и постоянно нуждаемся в новых людях. С Huntica мы можем использовать один QR-код для приглашения на все вакансии. Мы разместили QR-код на бумажных и электронных билетах на концерты и получаем отклики с записанным интервью от тех, кто любит музыку и нашу площадку. Так можно набрать и волонтеров для музыкального фестиваля, и специалиста по освещению сцены. Универсальный инструмент!'
  company2: Loud Sound Hall
  content3: 'Мы нашли способ максимально использовать Huntica для экономии своих ресурсов. Как небольшая мебельная фабрика, мы приспособили баннер на фасаде нашего здания для поиска новых кандидатов с помощью QR-кода от Huntica. Таким образом, у нас стало больше кандидатов, которые живут в окрестностях фабрики. Две трети новых сотрудников пришли через QR-код и онлайн-собеседование.'
  company3: Фабрика Rosewood
  content4: 'В нашем ресторане все зеркала используются для приглашения будущих сотрудников. Это очень удобно: в небольшой наклейке можно разместить всю необходимую информацию, а посетители обязательно обратят внимание, заглядывая в зеркало. Все желающие могут пройти собеседование в Huntica, а нам остается принимать решение, кого из откликнувшихся кандидатов пригласить. Мы видим интерес посетителей к вакансиям нашего ресторана и очень рады этому!'
  company4: Aubergine
  content5: 'Наша компания выступала спонсором научной конференции для студентов IT специальностей, и нам требовалось простое решения для приглашения всех участников на стажировку в нашу компанию. С Huntica удалось сделать приглашение с QR кодом для размещения рядом символикой конференции и существенно сократить временные затраты на последующее знакомство с кандидатами. С таким инструментом мы можем приглашать больше участников и не переживать о нехватке HR специалистов для такой объемной задачи.'
  company5: Параллели
  content6: 'Мы решили дополнить дизайн наших пакетов для покупок QR-кодом от Huntica, и теперь информация о наших вакансиях расходится вместе с нашими покупателями, достигая их друзей и знакомых, которые тоже разделяют интерес к здоровому питанию. Мы экономим время на поиске кандидатов и первичном собеседовании и получаем заинтересованных сотрудников.'
  company6: Herbarium
  content7: 'Дизайн наших стаканчиков для кофе с собой дополняет QR-код и приглашает ознакомиться с открытыми вакансиями всех, кто приходит к нам за кофе. Наш кофе теперь сам приглашает будущих сотрудников, а процесс отбора кандидатов стал намного проще без необходимости согласовывать время собеседования с каждым кандидатом.'
  company7: Cava Coffee
</i18n>

<!-- eslint-enable max-len -->
